import {
  useStyle 
} from "@/classify"
import PriceComponent from "@/components/Price"
import {
  BrowserPersistence 
} from "@/util"
import {
  Fragment 
} from "react"
import defaultClasses from "./price.module.css"

const storage = new BrowserPersistence()

const Price = (props) => {
  const classes = useStyle(defaultClasses, props.classes)
  const {
    attribute_metadata = {}, entered_attribute_value = {} 
  } = props

  // TODO: Get complete price data from GraphQl including currency
  const storeCurrency = storage.getItem("store_view_currency") || "USD"
  const attributeLabel = attribute_metadata.label ? (
    <div className={classes.label}>{attribute_metadata.label}</div>
  ) : null
  const attributeContent = entered_attribute_value.value ? (
    <div className={classes.attributeContent}>
      <PriceComponent
        value={parseInt(entered_attribute_value.value)}
        currencyCode={storeCurrency}
      />
    </div>
  ) : null

  return (
    <Fragment>
      {attributeLabel}
      {attributeContent}
    </Fragment>
  )
}

export default Price
